import React from "react";
import Markdown from "~/components/Markdown";
import Collapsable from "~/components/Collapsable";
import { Badge, Box, Link, Picture, Text } from "~/components-shared";
import { CollapsableTypeEnum } from "~/types/enums";
import moment from "moment";
import styled from "styled-components";
import FootprintActions from "~/components/FootprintActions";
const Underline = styled.span`
  text-decoration: underline;
`;
const TopicFootprintContentAsana = _ref => {
  let {
    footprint,
    hideDetails = false,
    hideMessage = false
  } = _ref;
  const {
    actions,
    data: {
      issueCompleted,
      issueStatusName,
      issueTitle,
      issueCustomFields,
      issueSubtaskCount,
      issueLikeCount,
      dependencies,
      dependents,
      issueLabels,
      issueDescription,
      issueUrl,
      assigneeName,
      assigneeAvatar,
      assigneeUrl,
      issueDueOn,
      comment,
      projects
    }
  } = footprint;
  const showExtra = !!(issueCustomFields && issueCustomFields.length) || !!issueSubtaskCount || !!issueLikeCount || !!(dependencies && dependencies.length) || !!(dependents && dependents.length);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !hideDetails && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    display: "block",
    color: "textSecondary",
    weight: "semiBold"
  }, /*#__PURE__*/React.createElement(FootprintActions, {
    actions: actions
  }), " an Asana", " ", /*#__PURE__*/React.createElement(Link, {
    href: issueUrl,
    underline: true
  }, "task"), assigneeName && /*#__PURE__*/React.createElement(Text, null, " ", "assigned to", " ", assigneeAvatar && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Picture, {
    src: assigneeAvatar,
    width: "1.4rem",
    height: "1.4rem",
    display: "inline-block",
    border: "circled",
    s: {
      mb: -1
    }
  }), " "), /*#__PURE__*/React.createElement(Link, {
    href: assigneeUrl,
    underline: true
  }, assigneeName), " "), !!issueLabels?.length && /*#__PURE__*/React.createElement(Text, null, " ", "labelled with ", /*#__PURE__*/React.createElement(Underline, null, issueLabels.join("*, *"))), !!issueDueOn && /*#__PURE__*/React.createElement(Text, null, " ", "with due date on ", /*#__PURE__*/React.createElement(Underline, null, moment(issueDueOn, "YYYY-MM-DD").format("ddd, MMM D"))), !!projects.length && /*#__PURE__*/React.createElement(React.Fragment, null, " ", "on", " ", projects.map(project => /*#__PURE__*/React.createElement(Link, {
    key: project.id,
    href: "",
    underline: true,
    s: {
      mr: 1
    }
  }, project.name)), "project")), /*#__PURE__*/React.createElement(Text, {
    weight: "semiBold",
    fontSize: 4.5,
    lineHeight: 6.5,
    display: "block",
    s: {
      my: 1
    }
  }, issueTitle || "No task name", /*#__PURE__*/React.createElement(Badge, {
    color: issueCompleted ? "translucentSuccess" : "translucent",
    display: "inline",
    s: {
      py: 0.5,
      mx: 2
    }
  }, issueCompleted ? "Completed" : issueStatusName || "Not Completed")), showExtra && /*#__PURE__*/React.createElement(Box, {
    wrap: "wrap",
    gap: 1,
    s: {
      mb: 3,
      mt: 2
    }
  }, issueCustomFields?.map(field => /*#__PURE__*/React.createElement(Badge, {
    color: "translucentPrimary"
  }, field.name, ": ", field.value)), !!issueSubtaskCount && /*#__PURE__*/React.createElement(Badge, {
    color: "translucentPrimary"
  }, "Subtasks: ", issueSubtaskCount), !!issueLikeCount && /*#__PURE__*/React.createElement(Badge, {
    color: "translucentPrimary"
  }, "Liked: ", issueLikeCount), !!dependencies && !!dependencies.length && /*#__PURE__*/React.createElement(Badge, {
    color: "translucentPrimary"
  }, "Dependencies: ", dependencies.length), !!dependents && !!dependents.length && /*#__PURE__*/React.createElement(Badge, {
    color: "translucentPrimary"
  }, "Dependents: ", dependents.length)), issueDescription && /*#__PURE__*/React.createElement(Collapsable, {
    maxHeight: 0,
    type: CollapsableTypeEnum.BUTTON,
    s: {
      mb: 3
    },
    collapsedText: "View task description",
    expandedText: "Hide task description"
  }, /*#__PURE__*/React.createElement(Markdown, {
    text: issueDescription,
    fontSize: 4,
    lineHeight: 6,
    display: "block"
  }))), !hideMessage && comment && /*#__PURE__*/React.createElement(Collapsable, {
    s: {
      mb: 1
    }
  }, /*#__PURE__*/React.createElement(Markdown, {
    text: comment,
    fontSize: 4,
    lineHeight: 6,
    display: "block"
  })));
};
export default TopicFootprintContentAsana;